export default function convertHtmlToPlainText(html: string): string {
    try {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const styleElements = doc.querySelectorAll('style');
        if (styleElements && styleElements.length > 0) {
            for (let i = 0; i < styleElements.length; i++) {
                if (styleElements[i]) {
                    styleElements[i].innerHTML = '';
                }
            }
        }
        return doc.body.textContent || '';
    } catch (e) {
        return '';
    }
}
